module.exports = __webpack_public_path__ + "static/media/Icon_PGD_Grey70.cb029f25.png";